export { EloTextAlignCenterIcon } from './text-align-center-icon'
